// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA7dZA3J8SbsBnyYbhiu-RYgGHMX3Mb4oA",
    authDomain: "csg-guardtour-2.firebaseapp.com",
    databaseURL: "https://csg-guardtour-2.firebaseio.com",
    projectId: "csg-guardtour-2",
    storageBucket: "csg-guardtour-2.appspot.com",
    messagingSenderId: "436270852701"
  }
};
